import { memo, useCallback, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { Button } from '@cbhq/cds-web/buttons';
import { SpotRectangle } from '@cbhq/cds-web/illustrations/SpotRectangle';
import { VStack } from '@cbhq/cds-web/layout';
import { TextBody, TextTitle1 } from '@cbhq/cds-web/typography';

import { AnalyticEvent } from ':fat/analytics/events';
import { logGenericEvent, logRender } from ':fat/analytics/logActions';
import { BalancesBanner } from ':fat/components/BalancesBanner/BalancesBanner';
import { SingleColumnLayout } from ':fat/components/PageLayout/SingleColumnLayout';
import { messages } from ':fat/pages/GetStartedPage/GetStartedPageMessages';
import { AppRoutes } from ':fat/routing/routes';

export const GetStartedPage = memo(function GetStartedPage() {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();

  useEffect(() => {
    logRender(AnalyticEvent.GetStartedPageRendered);
  }, []);

  const onAdvanceHandler = useCallback(() => {
    logGenericEvent(AnalyticEvent.GetStartedButtonClicked);
    navigate(AppRoutes.SECURITY_FRAME_LOADER);
  }, [navigate]);

  return (
    <SingleColumnLayout>
      <VStack gap={4} maxWidth={450} spacing={4}>
        <VStack alignItems="center" justifyContent="center">
          <SpotRectangle name="transferCoins" scaleMultiplier={1} />
          <TextTitle1 as="h2" spacingTop={4}>
            {formatMessage(messages.title)}
          </TextTitle1>
          <TextBody as="p" color="foregroundMuted">
            {formatMessage(messages.description)}
          </TextBody>
        </VStack>
        <BalancesBanner />
        <Button testID="landing-page-button" block onPress={onAdvanceHandler}>
          {formatMessage(messages.button)}
        </Button>
      </VStack>
    </SingleColumnLayout>
  );
});
